// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .mat-mdc-select-panel {
  scrollbar-width: thin;
  scrollbar-color: rgba(155, 155, 155, 0.7) transparent;
}
::ng-deep .mat-mdc-select-panel::-webkit-scrollbar {
  width: 6px;
}
::ng-deep .mat-mdc-select-panel::-webkit-scrollbar-track {
  background: transparent;
}
::ng-deep .mat-mdc-select-panel::-webkit-scrollbar-thumb {
  background: rgba(155, 155, 155, 0.7);
  border-radius: 3px;
}

.content {
  height: calc(100% - 20px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 0.75rem;
  gap: 0.75rem;
}

.detail-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  gap: 0.5rem;
}
.detail-loading ::ng-deep app-spinner {
  display: block;
  width: 32px;
  height: 32px;
  position: relative;
}
.detail-loading ::ng-deep app-spinner mat-spinner {
  position: static !important;
  top: auto !important;
  left: auto !important;
  width: 32px !important;
  height: 32px !important;
  opacity: 0.7;
}
.detail-loading ::ng-deep app-spinner mat-spinner svg {
  width: 32px !important;
  height: 32px !important;
}
.detail-loading p {
  font-size: 12px;
  opacity: 0.7;
  margin: 0;
}

.detail-error {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 0.75rem;
  border: 1px solid rgba(244, 67, 54, 0.3);
  border-radius: 4px;
  background: rgba(244, 67, 54, 0.05);
  font-size: 12px;
  color: #ef5350;
}
.detail-error mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}

.detail-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}
.detail-header .detail-model-name {
  font-weight: 500;
  font-size: 13px;
  font-family: monospace;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}
.detail-header .detail-spacer {
  flex: 1;
}
.detail-header button {
  flex-shrink: 0;
}
.detail-header button mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.detail-header button mat-icon.spinning {
  animation: spin 1s linear infinite;
}
.detail-header button[color=primary] {
  color: #fff;
}
.detail-header .detail-result-group {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.35rem 0.75rem;
  border: 1px solid rgba(76, 175, 80, 0.3);
  border-radius: 4px;
  background: rgba(76, 175, 80, 0.05);
}
.detail-header .detail-result-group .detail-result-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.detail-header .detail-result-group .detail-result-label {
  font-size: 9px;
  text-transform: uppercase;
  font-weight: 600;
  opacity: 0.5;
  line-height: 1;
}
.detail-header .detail-result-group .detail-result-values {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}
.detail-header .detail-result-group .detail-result-value {
  font-family: monospace;
  font-size: 13px;
  font-weight: 500;
}
.detail-header .detail-result-group .truth-input {
  width: 60px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 3px;
  background: var(--preset-background, #1e1e1e);
  color: inherit;
  font-family: monospace;
  font-size: 13px;
  font-weight: 500;
  padding: 1px 4px;
  outline: none;
  -moz-appearance: textfield;
}
.detail-header .detail-result-group .truth-input:focus {
  border-color: #4fc3f7;
}
.detail-header .detail-result-group .truth-input::placeholder {
  opacity: 0.4;
}
.detail-header .detail-result-group .truth-input::-webkit-outer-spin-button, .detail-header .detail-result-group .truth-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.detail-header .detail-result-group .correct-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.detail-header .detail-result-group .correct-icon.correct {
  color: #66bb6a;
}
.detail-header .detail-result-group .correct-icon.incorrect {
  color: #ef5350;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.detail-tabs {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.detail-tabs ::ng-deep .mat-mdc-tab-header {
  --mat-tab-container-height: 28px;
}
.detail-tabs ::ng-deep .mat-mdc-tab-labels {
  justify-content: flex-start;
}
.detail-tabs ::ng-deep .mdc-tab {
  min-width: auto;
  padding: 0 12px;
  font-size: 11px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  font-weight: 500;
}
.detail-tabs ::ng-deep .mat-mdc-tab-body-wrapper {
  flex: 1;
  min-height: 0;
}
.detail-tabs ::ng-deep .mat-mdc-tab-body-content {
  height: 100%;
  overflow: hidden;
}

.detail-impact {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.detail-impact .scichart-container {
  flex: 1;
  min-height: 0;
  width: 100%;
  touch-action: none;
}

.detail-features {
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.detail-features .detail-features-header {
  display: flex;
  align-items: flex-end;
  gap: 1rem;
  padding: 10px 0;
}
.detail-features .detail-features-header .feature-selector {
  font-size: 12px;
}
.detail-features .detail-features-header .feature-selector ::ng-deep .mat-mdc-form-field-subscript-wrapper {
  display: none;
}
.detail-features .detail-features-header .text-subtle {
  font-size: 18px;
  white-space: nowrap;
  margin-bottom: 6px;
}
.detail-features .detail-features-header .reset-btn {
  margin-left: auto;
  margin-bottom: 4px;
  width: 32px;
  height: 32px;
  padding: 0;
}
.detail-features .detail-features-header .reset-btn ::ng-deep .mat-mdc-button-touch-target {
  width: 32px;
  height: 32px;
}
.detail-features .detail-features-header .reset-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.detail-features .detail-features-header .view-toggle {
  margin-bottom: 4px;
  height: 32px;
  font-size: 0;
}
.detail-features .detail-features-header .view-toggle ::ng-deep .mat-button-toggle-label-content {
  padding: 0 8px;
  line-height: 32px;
}
.detail-features .detail-features-header .view-toggle mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.detail-features .detail-chart-wrapper {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}
.detail-features .detail-chart-wrapper .scichart-container {
  width: 100%;
  height: 100%;
  touch-action: none;
}
.detail-features .detail-table-wrapper {
  flex: 1;
  min-height: 0;
  overflow: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(155, 155, 155, 0.7) transparent;
}
.detail-features .detail-table-wrapper table {
  width: 100%;
  font-size: 11px;
  --mat-table-row-item-container-height: 24px;
}
.detail-features .detail-table-wrapper th, .detail-features .detail-table-wrapper td {
  padding: 2px 6px;
  font-family: monospace;
  font-size: 11px;
}
.detail-features .detail-table-wrapper td.editable {
  cursor: pointer;
  position: relative;
}
.detail-features .detail-table-wrapper td.editable:hover:not(.editing) {
  background-color: var(--preset-hover);
}
.detail-features .detail-table-wrapper td.editing {
  padding: 0;
}
.detail-features .detail-table-wrapper .cell-input {
  position: absolute;
  top: 0;
  left: 0;
  width: 10ch;
  min-width: 100%;
  border: 1px solid #4fc3f7;
  background: var(--preset-background, #1e1e1e);
  color: inherit;
  font-family: monospace;
  font-size: 11px;
  padding: 1px 5px;
  box-sizing: border-box;
  outline: none;
  height: 100%;
  z-index: 1;
}
.detail-features .detail-table-wrapper .cell-input:focus {
  border-color: #0288d1;
}
.detail-features .detail-table-wrapper ::ng-deep .mat-mdc-paginator {
  font-size: 11px;
  --mat-paginator-container-size: 32px;
}

.text-subtle {
  opacity: 0.6;
  font-size: 0.85em;
}`, "",{"version":3,"sources":["webpack://./src/app/components/strategy-grid/playground-detail-widget/playground-detail-widget.component.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,qDAAA;AACF;AACE;EACE,UAAA;AACJ;AACE;EACE,uBAAA;AACJ;AACE;EACE,oCAAA;EACA,kBAAA;AACJ;;AAGA;EACE,yBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,OAAA;EACA,WAAA;AAAF;AAEE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AAAJ;AAEI;EACE,2BAAA;EACA,oBAAA;EACA,qBAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;AAAN;AAEM;EACE,sBAAA;EACA,uBAAA;AAAR;AAKE;EACE,eAAA;EACA,YAAA;EACA,SAAA;AAHJ;;AAOA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,wCAAA;EACA,kBAAA;EACA,mCAAA;EACA,eAAA;EACA,cAAA;AAJF;AAME;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAJJ;;AAQA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;AALF;AAOE;EACE,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AALJ;AAQE;EACE,OAAA;AANJ;AASE;EACE,cAAA;AAPJ;AASI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAPN;AASM;EACE,kCAAA;AAPR;AAWI;EACE,WAAA;AATN;AAaE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,wBAAA;EACA,wCAAA;EACA,kBAAA;EACA,mCAAA;AAXJ;AAaI;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AAXN;AAcI;EACE,cAAA;EACA,yBAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;AAZN;AAeI;EACE,aAAA;EACA,mBAAA;EACA,YAAA;AAbN;AAgBI;EACE,sBAAA;EACA,eAAA;EACA,gBAAA;AAdN;AAiBI;EACE,WAAA;EACA,0CAAA;EACA,kBAAA;EACA,6CAAA;EACA,cAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EAeA,0BAAA;AA7BN;AAgBM;EACE,qBAAA;AAdR;AAiBM;EACE,YAAA;AAfR;AAkBM;EAEE,wBAAA;EACA,SAAA;AAjBR;AAsBI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AApBN;AAsBM;EACE,cAAA;AApBR;AAuBM;EACE,cAAA;AArBR;;AA2BA;EACE;IAAO,uBAAA;EAvBP;EAwBA;IAAK,yBAAA;EArBL;AACF;AAuBA;EACE,OAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AArBF;AAuBE;EACE,gCAAA;AArBJ;AAwBE;EACE,2BAAA;AAtBJ;AAyBE;EACE,eAAA;EACA,eAAA;EACA,eAAA;EACA,sBAAA;EACA,yBAAA;EACA,gBAAA;AAvBJ;AA0BE;EACE,OAAA;EACA,aAAA;AAxBJ;AA2BE;EACE,YAAA;EACA,gBAAA;AAzBJ;;AA6BA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;AA1BF;AA4BE;EACE,OAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;AA1BJ;;AA8BA;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AA3BF;AA6BE;EACE,aAAA;EACA,qBAAA;EACA,SAAA;EACA,eAAA;AA3BJ;AA6BI;EACE,eAAA;AA3BN;AA6BM;EACE,aAAA;AA3BR;AA+BI;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;AA7BN;AAgCI;EACE,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AA9BN;AAgCM;EACE,WAAA;EACA,YAAA;AA9BR;AAiCM;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA/BR;AAmCI;EACE,kBAAA;EACA,YAAA;EACA,YAAA;AAjCN;AAmCM;EACE,cAAA;EACA,iBAAA;AAjCR;AAoCM;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAlCR;AAuCE;EACE,OAAA;EACA,aAAA;EACA,gBAAA;AArCJ;AAuCI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AArCN;AAyCE;EACE,OAAA;EACA,aAAA;EACA,cAAA;EACA,qBAAA;EACA,qDAAA;AAvCJ;AAyCI;EACE,WAAA;EACA,eAAA;EACA,2CAAA;AAvCN;AA0CI;EACE,gBAAA;EACA,sBAAA;EACA,eAAA;AAxCN;AA2CI;EACE,eAAA;EACA,kBAAA;AAzCN;AA2CM;EACE,qCAAA;AAzCR;AA6CI;EACE,UAAA;AA3CN;AA8CI;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;EACA,6CAAA;EACA,cAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;EACA,UAAA;AA5CN;AA8CM;EACE,qBAAA;AA5CR;AAgDI;EACE,eAAA;EACA,oCAAA;AA9CN;;AAmDA;EACE,YAAA;EACA,iBAAA;AAhDF","sourcesContent":["::ng-deep .mat-mdc-select-panel {\n  scrollbar-width: thin;\n  scrollbar-color: rgba(155, 155, 155, 0.7) transparent;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n  }\n  &::-webkit-scrollbar-track {\n    background: transparent;\n  }\n  &::-webkit-scrollbar-thumb {\n    background: rgba(155, 155, 155, 0.7);\n    border-radius: 3px;\n  }\n}\n\n.content {\n  height: calc(100% - 20px);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  padding: 0.75rem;\n  gap: 0.75rem;\n}\n\n.detail-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  gap: 0.5rem;\n\n  ::ng-deep app-spinner {\n    display: block;\n    width: 32px;\n    height: 32px;\n    position: relative;\n\n    mat-spinner {\n      position: static !important;\n      top: auto !important;\n      left: auto !important;\n      width: 32px !important;\n      height: 32px !important;\n      opacity: 0.7;\n\n      svg {\n        width: 32px !important;\n        height: 32px !important;\n      }\n    }\n  }\n\n  p {\n    font-size: 12px;\n    opacity: 0.7;\n    margin: 0;\n  }\n}\n\n.detail-error {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.5rem 0.75rem;\n  border: 1px solid rgba(244, 67, 54, 0.3);\n  border-radius: 4px;\n  background: rgba(244, 67, 54, 0.05);\n  font-size: 12px;\n  color: #ef5350;\n\n  mat-icon {\n    font-size: 16px;\n    width: 16px;\n    height: 16px;\n  }\n}\n\n.detail-header {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n\n  .detail-model-name {\n    font-weight: 500;\n    font-size: 13px;\n    font-family: monospace;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    min-width: 0;\n  }\n\n  .detail-spacer {\n    flex: 1;\n  }\n\n  button {\n    flex-shrink: 0;\n\n    mat-icon {\n      font-size: 16px;\n      width: 16px;\n      height: 16px;\n\n      &.spinning {\n        animation: spin 1s linear infinite;\n      }\n    }\n\n    &[color=\"primary\"] {\n      color: #fff;\n    }\n  }\n\n  .detail-result-group {\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    padding: 0.35rem 0.75rem;\n    border: 1px solid rgba(76, 175, 80, 0.3);\n    border-radius: 4px;\n    background: rgba(76, 175, 80, 0.05);\n\n    .detail-result-item {\n      display: flex;\n      flex-direction: column;\n      align-items: flex-start;\n    }\n\n    .detail-result-label {\n      font-size: 9px;\n      text-transform: uppercase;\n      font-weight: 600;\n      opacity: 0.5;\n      line-height: 1;\n    }\n\n    .detail-result-values {\n      display: flex;\n      align-items: center;\n      gap: 0.25rem;\n    }\n\n    .detail-result-value {\n      font-family: monospace;\n      font-size: 13px;\n      font-weight: 500;\n    }\n\n    .truth-input {\n      width: 60px;\n      border: 1px solid rgba(255, 255, 255, 0.2);\n      border-radius: 3px;\n      background: var(--preset-background, #1e1e1e);\n      color: inherit;\n      font-family: monospace;\n      font-size: 13px;\n      font-weight: 500;\n      padding: 1px 4px;\n      outline: none;\n\n      &:focus {\n        border-color: #4fc3f7;\n      }\n\n      &::placeholder {\n        opacity: 0.4;\n      }\n\n      &::-webkit-outer-spin-button,\n      &::-webkit-inner-spin-button {\n        -webkit-appearance: none;\n        margin: 0;\n      }\n      -moz-appearance: textfield;\n    }\n\n    .correct-icon {\n      font-size: 16px;\n      width: 16px;\n      height: 16px;\n\n      &.correct {\n        color: #66bb6a;\n      }\n\n      &.incorrect {\n        color: #ef5350;\n      }\n    }\n  }\n}\n\n@keyframes spin {\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n}\n\n.detail-tabs {\n  flex: 1;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n\n  ::ng-deep .mat-mdc-tab-header {\n    --mat-tab-container-height: 28px;\n  }\n\n  ::ng-deep .mat-mdc-tab-labels {\n    justify-content: flex-start;\n  }\n\n  ::ng-deep .mdc-tab {\n    min-width: auto;\n    padding: 0 12px;\n    font-size: 11px;\n    letter-spacing: 0.02em;\n    text-transform: uppercase;\n    font-weight: 500;\n  }\n\n  ::ng-deep .mat-mdc-tab-body-wrapper {\n    flex: 1;\n    min-height: 0;\n  }\n\n  ::ng-deep .mat-mdc-tab-body-content {\n    height: 100%;\n    overflow: hidden;\n  }\n}\n\n.detail-impact {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n\n  .scichart-container {\n    flex: 1;\n    min-height: 0;\n    width: 100%;\n    touch-action: none;\n  }\n}\n\n.detail-features {\n  height: 100%;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n\n  .detail-features-header {\n    display: flex;\n    align-items: flex-end;\n    gap: 1rem;\n    padding: 10px 0;\n\n    .feature-selector {\n      font-size: 12px;\n\n      ::ng-deep .mat-mdc-form-field-subscript-wrapper {\n        display: none;\n      }\n    }\n\n    .text-subtle {\n      font-size: 18px;\n      white-space: nowrap;\n      margin-bottom: 6px;\n    }\n\n    .reset-btn {\n      margin-left: auto;\n      margin-bottom: 4px;\n      width: 32px;\n      height: 32px;\n      padding: 0;\n\n      ::ng-deep .mat-mdc-button-touch-target {\n        width: 32px;\n        height: 32px;\n      }\n\n      mat-icon {\n        font-size: 18px;\n        width: 18px;\n        height: 18px;\n      }\n    }\n\n    .view-toggle {\n      margin-bottom: 4px;\n      height: 32px;\n      font-size: 0;\n\n      ::ng-deep .mat-button-toggle-label-content {\n        padding: 0 8px;\n        line-height: 32px;\n      }\n\n      mat-icon {\n        font-size: 20px;\n        width: 20px;\n        height: 20px;\n      }\n    }\n  }\n\n  .detail-chart-wrapper {\n    flex: 1;\n    min-height: 0;\n    overflow: hidden;\n\n    .scichart-container {\n      width: 100%;\n      height: 100%;\n      touch-action: none;\n    }\n  }\n\n  .detail-table-wrapper {\n    flex: 1;\n    min-height: 0;\n    overflow: auto;\n    scrollbar-width: thin;\n    scrollbar-color: rgba(155, 155, 155, 0.7) transparent;\n\n    table {\n      width: 100%;\n      font-size: 11px;\n      --mat-table-row-item-container-height: 24px;\n    }\n\n    th, td {\n      padding: 2px 6px;\n      font-family: monospace;\n      font-size: 11px;\n    }\n\n    td.editable {\n      cursor: pointer;\n      position: relative;\n\n      &:hover:not(.editing) {\n        background-color: var(--preset-hover);\n      }\n    }\n\n    td.editing {\n      padding: 0;\n    }\n\n    .cell-input {\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 10ch;\n      min-width: 100%;\n      border: 1px solid #4fc3f7;\n      background: var(--preset-background, #1e1e1e);\n      color: inherit;\n      font-family: monospace;\n      font-size: 11px;\n      padding: 1px 5px;\n      box-sizing: border-box;\n      outline: none;\n      height: 100%;\n      z-index: 1;\n\n      &:focus {\n        border-color: #0288d1;\n      }\n    }\n\n    ::ng-deep .mat-mdc-paginator {\n      font-size: 11px;\n      --mat-paginator-container-size: 32px;\n    }\n  }\n}\n\n.text-subtle {\n  opacity: 0.6;\n  font-size: 0.85em;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
